module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if( isTurbo ) { %> <div class=\"turbo-wrapper\"> <h1 class=\"headline\"><%- turbo_vote_headline %></h1> <p class=\"description\"><%- turbo_vote_paragraph %></p> </div> <% } %> <div class=\"vote-cta\"> <div class=\"text-wrapper\"> <h1 class=\"headline\"><%- headline1 %></h1> <% if(headline2.length > 0) { %> <h2 class=\"subheadline\"><%- headline2 %></h2> <% } %> <% if(headline3.length) { %> <h3 class=\"description\"><%- headline3 %></h3> <% } %> <% if(sponsor_img !== '') { %> <div class=\"sponsor\"> <span><%- sponsor_text %></span><img src=\"<%= sponsor_img %>\" alt=\"\"> </div> <% } %> <div class=\"tswdg-countdown\"></div> </div> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if( isTurbo ) { ; buf.push(' <div class="turbo-wrapper"> <h1 class="headline">', (__stack.lineno=1,  turbo_vote_headline ), '</h1> <p class="description">', (__stack.lineno=1,  turbo_vote_paragraph ), '</p> </div> ');__stack.lineno=1; } ; buf.push(' <div class="vote-cta"> <div class="text-wrapper"> <h1 class="headline">', (__stack.lineno=1,  headline1 ), '</h1> ');__stack.lineno=1; if(headline2.length > 0) { ; buf.push(' <h2 class="subheadline">', (__stack.lineno=1,  headline2 ), '</h2> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(headline3.length) { ; buf.push(' <h3 class="description">', (__stack.lineno=1,  headline3 ), '</h3> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(sponsor_img !== '') { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=1,  sponsor_text ), '</span><img src="', escape((__stack.lineno=1,  sponsor_img )), '" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' <div class="tswdg-countdown"></div> </div> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/vote-cta.ejs
// module id = 214
// module chunks = 0